module.exports = __webpack_public_path__ + "img/widget-design_all.91c4d6fa.jpg";